import { __spreadArray, __read } from 'tslib';

function splicedItems(items, rowLength) {
    var localItems = __spreadArray([], __read(items), false);
    return __spreadArray([], __read(Array(Math.ceil(localItems.length / rowLength))), false).map(function () { return localItems.splice(0, rowLength); });
}

export { splicedItems };
//# sourceMappingURL=splicedItems.esm.js.map
